module.exports = __webpack_public_path__ + "assets/images/profiles/2020-4-desktop.jpg?v=db19dea3";